export default "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 26.1L33.8 0s10.5-.5 10.5 10.5c0 13.2-20.6 16.8-44.3 15.6z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M36.3 21.1V64L64 38.5z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./static/symbols/38.svg
// module id = 80
// module chunks = 0